export const opacity = {
  dark: {
    600: 'rgba(0,0,0,0.6)',
    400: 'rgba(0,0,0,0.4)',
    250: 'rgba(0,0,0,0.25)',
    200: 'rgba(0,0,0,0.2)',
    150: 'rgba(0,0,0,0.15)',
    100: 'rgba(0,0,0,0.1)',
    80: 'rgba(0,0,0,0.08)',
    50: 'rgba(0,0,0,0.05)',
  },
  light: {
    500: 'rgba(255,255,255,0.5)',
    400: 'rgba(255,255,255,0.4)',
    250: 'rgba(255,255,255,0.25)',
    80: 'rgba(255,255,255,0.08)',
    50: 'rgba(255,255,255,0.05)',
  },
  primary: {
    600: 'rgba(212,42,5,0.6)',
    500: 'rgba(212,42,5,0.5)',
    400: 'rgba(212,42,5,0.4)',
    250: 'rgba(212,42,5,0.25)',
    200: 'rgba(212,42,5,0.2)',
    150: 'rgba(212,42,5,0.15)',
    100: 'rgba(212,42,5,0.1)',
    80: 'rgba(212,42,5,0.08)',
    50: 'rgba(212,42,5,0.05)',
  },
  secondary: {
    600: 'rgba(255,204,0,0.6)',
    500: 'rgba(255,204,0,0.5)',
    400: 'rgba(255,204,0,0.4)',
    250: 'rgba(255,204,0,0.25)',
    200: 'rgba(255,204,0,0.2)',
    150: 'rgba(255,204,0,0.15)',
    100: 'rgba(255,204,0,0.1)',
    80: 'rgba(255,204,0,0.08)',
    50: 'rgba(255,204,0,0.05)',
  },
}
